import type { Appointments } from "@/lib/appointments"
import { buildCachedPayload } from "@/lib/caching/buildPayload"
import { Mirror } from "@/lib/mirror"

export const emptyAppointmentOfferingsPayload =
  buildCachedPayload<Appointments.OfferingsCache.Data>({
    cachedAt: 0,
    data: Mirror.build(),
  })
